<div class="pro-header__inner">
  <div class="pro-header__title">{{ productNav.name }}</div>
  <nav class="pro-header__nav">
    @for (room of productNav.rooms; track room.name) {
    <a class="pro-header__nav-link" routerLink="{{ room.path }}" routerLinkActive="pro-header__nav-link--current" [routerLinkActiveOptions]="{ exact: false }">
      {{ room.name }}
    </a>
    }
  </nav>
</div>
